/* eslint-disable react-hooks/exhaustive-deps */

/*
*   data by double click by ContentDoubleClickForm.tsx
*/

import { useEffect, useState } from "react";
import { IContentSelect, ILanding, SELECT_TYPE } from "../data/interfaces";
import { ILandingStore, useLandingStore } from "../data/store";
import { getLandingContainer } from "../views/utils/getLandingContainer";

export interface IEditedContent extends IContentSelect {
    element: Element | null
    data: any
}
export default function useEditedContent(): IEditedContent {
    const editElement : IContentSelect | null   = useLandingStore((state: ILandingStore) => state.editElement)
    const currentLanding: ILanding              = useLandingStore((state: ILandingStore) => state.currentLanding)
    const [element, setElement]                 = useState<Element | null>( null )
    const [data, setData]                       = useState<any>({})
    const getDOMElement = () => {
        const landing: Element = getLandingContainer()
        switch(editElement?.selectType) {
            case SELECT_TYPE.CONTENT:
                const el = landing.querySelector(`.landing-section-container.landing-gap[id="${editElement?.sectionId}"] .landing-content-container[data-content-id="${editElement?.id}"]`) 
                setElement(el)
                const section = currentLanding.sections.find(section => section.id === editElement.sectionId)
                const _data = section?.data.find(_d => _d.id === editElement.id)
                setData(_data)
                break
            default:
                setElement(null)
                setData({})
        }
        
    }
    useEffect(() => {
        getDOMElement()
    }, [editElement])
    return {
        ...editElement,
        data,
        element
    }
}